import React from "react";
import { motion } from "framer-motion";
import { HiOutlineGlobe, HiOutlineLightningBolt, HiOutlineLocationMarker } from "react-icons/hi";
import ourStoryImg from "../../../assets/img/our-story.webp";

const STATS = [
  { icon: HiOutlineGlobe, value: "4", label: "Translation Modes" },
  { icon: HiOutlineLightningBolt, value: "Real-time", label: "Processing" },
  { icon: HiOutlineLocationMarker, value: "Kampala - Uganda", label: "to the World" },
];

export default function AboutSection() {
  return (
    <section id="about" className="bg-white dark:bg-black py-16 sm:py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <motion.div
            initial={{ opacity: 0, x: -40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="flex-1"
          >
            <figure>
              <img
                src={ourStoryImg}
                alt="Children using sign language together"
                className="rounded-[20px] aboutUsShadow w-full object-contain"
              />
              <figcaption className="text-[#6A6A6A] dark:text-gray-500 font-sans text-xs mt-2 text-right">
                Photo: UNICEFKenya/2019/Rabenstein
              </figcaption>
            </figure>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="flex-1"
          >
            <h2 className="text-[#053676] dark:text-[#2A71E8] font-sans font-bold text-3xl sm:text-4xl mb-6">
              Our Story
            </h2>
            <p className="text-[#09062C] dark:text-white font-sans font-medium text-[16px] leading-relaxed mb-4">
              DMB Translation Services is a Social-Enterprise seeking to inspire
              inclusive communities for people living with disabilities through the
              development and provision of modern, affordable, and reliable assistive
              technologies.
            </p>
            <p className="text-[#09062C] dark:text-gray-300 font-sans text-[15px] leading-relaxed mb-8">
              Founded in Kampala, Uganda, we believe communication is a fundamental
              human right. Our flagship product — Chusa App — is
              a web and mobile application that translates Sign Language to Speech and
              Text, and vice versa, all in real-time. We are on a mission to bridge
              the gap between the deaf and hearing communities, empowering our societies
              to maximize their potential.
            </p>

            <div className="grid grid-cols-3 gap-4">
              {STATS.map(({ icon: Icon, value, label }) => (
                <div
                  key={label}
                  className="text-center p-3 rounded-[20px] bg-[#f4f4f4] dark:bg-[#181818]"
                >
                  <Icon className="w-6 h-6 text-[#2A71E8] mx-auto mb-2" />
                  <p className="text-[#053676] dark:text-[#2A71E8] font-sans font-bold text-lg">
                    {value}
                  </p>
                  <p className="text-[#09062C] dark:text-gray-400 font-sans text-xs">
                    {label}
                  </p>
                </div>
              ))}
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
